import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { iconColor } from 'utils/helpers'

export const XIcon = () => {
    const { darkMode } = useSelector((state: RootState) => state.globals)
    const stroke = iconColor(darkMode)
    return <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M7.1875 1.00024L1.00032 7.29159' stroke={stroke} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M1 1L7.18718 7.29135' stroke={stroke} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
    </svg>

}